import { GiHamburgerMenu } from "react-icons/gi";
import {
  IoCreateOutline,
  IoBookmarksOutline,
  IoLogOutOutline,
  IoPersonOutline,
  IoTrashOutline,
} from "react-icons/io5";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import Toggle from "../ThemeToggle";
import axios from "axios";
import { useEffect, useState } from "react";
import { baseURL, logoutUser } from "../../redux/Action";
import { useDispatch } from "react-redux";
import { FiUser } from "react-icons/fi";

const Navbar = () => {
  const [isAuth, setIsAuth] = useState(true);
  const [user, setUser] = useState({});
  const [show, setShow] = useState(false);
  const [showham, setShowham] = useState(false);
  const path = useLocation();
  const dispatch = useDispatch();

  const auth = localStorage.getItem("isAuth") || false;

  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem("User")) || {};
    setIsAuth(auth);
    setUser(userDetails);
  }, [auth]);

  const navigate = useNavigate();
  const logout = () => {
    axios
      .get(`${baseURL}/logout`, {
        withCredentials: true,
      })
      .then(() => {
        setIsAuth(false);
        setShow(false);
        logoutUser(dispatch);
        navigate("/");
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const modalContent1 = document.getElementById("modalContent");
      const modalContent2 = document.getElementById("modalContent2");
      const modalContentbtn = document.getElementById("modalContent1");
      const modalContent2btn = document.getElementById("modalContent2btn");

      if (
        modalContent1 &&
        !modalContent1.contains(event.target) &&
        !modalContentbtn.contains(event.target)
      ) {
        setShowham(false);
      }
      if (
        modalContent2 &&
        !modalContent2.contains(event.target) &&
        !modalContent2btn.contains(event.target)
      ) {
        setShow(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setShowham, setShow]);

  return (
    <div className="fixed top-0 left-0 w-full z-[1000] bg-white dark:bg-[#0a0a0a] border-b border-black dark:border-white/30 transition-colors duration-300">
      <header className="w-full flex justify-between items-center px-6 md:px-12 py-4">
        {/* LEFT: BRANDING & METADATA */}
        <div className="flex items-start gap-4">
          <NavLink
            to="/"
            className="text-2xl font-black uppercase tracking-tighter text-black dark:text-white leading-none"
          >
            Blogshog
            <br />
            <span className="text-[10px] font-mono tracking-widest font-normal">
              Studio
            </span>
          </NavLink>
          <div className="hidden lg:flex flex-col justify-between h-full pt-1">
            <span className="text-[10px] uppercase font-mono text-black dark:text-white leading-none">
              All Rights Reserved
            </span>
            <span className="text-[10px] uppercase font-mono text-black dark:text-white leading-none mt-1">
              Est. 2022
            </span>
          </div>
        </div>

        {/* CENTER: PILL NAVIGATION (BRUTALIST) */}
        <div className="hidden md:flex items-center gap-3">
          <NavLink
            to="/"
            className={`px-5 py-2 border border-black dark:border-white/30/40 rounded-full text-xs font-bold uppercase tracking-widest transition-colors ${path.pathname === "/" ? "bg-black text-white dark:bg-white dark:text-black" : "text-black dark:text-white hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black"}`}
          >
            Home
          </NavLink>
          <NavLink
            to="/blogs"
            className={`px-5 py-2 border border-black dark:border-white/30/40 rounded-full text-xs font-bold uppercase tracking-widest transition-colors ${path.pathname === "/blogs" ? "bg-black text-white dark:bg-white dark:text-black" : "text-black dark:text-white hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black"}`}
          >
            Journal
          </NavLink>
          <NavLink
            to="/blogs/create"
            className={`px-5 py-2 border border-black dark:border-white/30/40 rounded-full text-xs font-bold uppercase tracking-widest transition-colors ${path.pathname === "/blogs/create" ? "bg-black text-white dark:bg-white dark:text-black" : "text-black dark:text-white hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black"}`}
          >
            Initiate Project
          </NavLink>
          {isAuth && (
            <NavLink
              to="/blogs/trash"
              className={`px-5 py-2 border border-black dark:border-white/30/40 rounded-full text-xs font-bold uppercase tracking-widest transition-colors ${path.pathname === "/blogs/trash" ? "bg-black text-white dark:bg-white dark:text-black" : "text-black dark:text-white hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black"}`}
            >
              Trash
            </NavLink>
          )}
        </div>

        {/* RIGHT: METADATA, TOGGLE & USER */}
        <div className="flex items-center gap-4 sm:gap-8">
          <div className="flex items-center gap-4">
            <Toggle />

            {/* Mobile Nav Toggle */}
            <div className="relative block md:hidden">
              <button
                id="modalContent1"
                className="p-2 border border-black dark:border-white/30/40 rounded-full text-black dark:text-white"
                onClick={() => setShowham(!showham)}
              >
                <GiHamburgerMenu className="text-sm" />
              </button>
              {showham && (
                <div
                  id="modalContent"
                  className="absolute right-0 mt-2 w-48 border border-black dark:border-white/30/40 bg-white dark:bg-[#0a0a0a] ring-1 ring-black ring-opacity-5 focus:outline-none z-50 rounded-none shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] dark:shadow-[4px_4px_0px_0px_rgba(255,255,255,0.2)]"
                >
                  <Link
                    to="/blogs"
                    onClick={() => setShowham(false)}
                    className="flex items-center gap-3 px-4 py-3 text-xs font-mono font-bold uppercase text-black dark:text-white border-b border-black dark:border-white/30 hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors"
                  >
                    <IoBookmarksOutline className="text-lg" /> Journal
                  </Link>
                  <Link
                    to="/blogs/create"
                    onClick={() => setShowham(false)}
                    className="flex items-center gap-3 px-4 py-3 text-xs font-mono font-bold uppercase text-black dark:text-white border-b border-black dark:border-white/30 hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors"
                  >
                    <IoCreateOutline className="text-lg" /> Initiate
                  </Link>
                  {!isAuth ? (
                    <>
                      <Link
                        to="/login"
                        onClick={() => setShowham(false)}
                        className="flex items-center gap-3 px-4 py-3 text-xs font-mono font-bold uppercase text-black dark:text-white border-b border-black dark:border-white/30 hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors"
                      >
                        <FiUser className="text-lg" /> Login
                      </Link>
                      <Link
                        to="/signup"
                        onClick={() => setShowham(false)}
                        className="flex items-center gap-3 px-4 py-3 text-xs font-mono font-bold uppercase text-black dark:text-white hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors"
                      >
                        <FiUser className="text-lg" /> Create Account
                      </Link>
                    </>
                  ) : (
                    <Link
                      to="/blogs/trash"
                      onClick={() => setShowham(false)}
                      className="flex items-center gap-3 px-4 py-3 text-xs font-mono font-bold uppercase text-black dark:text-white hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors"
                    >
                      <IoTrashOutline className="text-lg" /> Trash
                    </Link>
                  )}
                </div>
              )}
            </div>

            {/* Desktop User Menu */}
            {isAuth ? (
              <div className="relative hidden sm:block">
                <button
                  id="modalContent2btn"
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-black dark:border-white/30/40 overflow-hidden focus:outline-none hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors bg-white dark:bg-black text-black dark:text-white"
                  onClick={() => setShow(!show)}
                >
                  {user?.user?.avatar ? (
                    <img
                      src={user.user.avatar}
                      alt="avatar"
                      className="h-full w-full object-cover grayscale"
                    />
                  ) : (
                    <IoPersonOutline className="text-lg" />
                  )}
                </button>

                {show && (
                  <div
                    id="modalContent2"
                    className="absolute right-0 mt-2 w-56 border border-black dark:border-white/30/40 bg-white dark:bg-[#0a0a0a] z-50 rounded-none shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] dark:shadow-[4px_4px_0px_0px_rgba(255,255,255,0.2)]"
                  >
                    <div className="px-4 py-3 border-b border-black dark:border-white/30">
                      <p className="text-xs font-bold uppercase tracking-wide text-black dark:text-white truncate">
                        {user?.user?.name || "User"}
                      </p>
                      <p className="text-[10px] font-mono text-gray-500 dark:text-gray-400 truncate mt-1">
                        {user?.user?.email || "Signed in"}
                      </p>
                    </div>

                    <Link
                      to="/profile"
                      onClick={() => setShow(false)}
                      className="flex items-center gap-3 px-4 py-3 text-xs font-mono font-bold uppercase text-black dark:text-white border-b border-black dark:border-white/30 hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors"
                    >
                      <IoPersonOutline className="text-lg" /> Profile
                    </Link>
                    <button
                      onClick={logout}
                      className="w-full flex items-center gap-3 px-4 py-3 text-xs font-mono font-bold uppercase text-red-600 dark:text-red-400 hover:bg-red-600 hover:text-white transition-colors text-left"
                    >
                      <IoLogOutOutline className="text-lg" /> Sign out
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <div className="hidden sm:flex items-center gap-3">
                <Link
                  to="/login"
                  className="px-4 py-1.5 border border-black dark:border-white/30/40 rounded-full text-[10px] font-bold uppercase tracking-widest text-black dark:text-white hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors"
                >
                  Log in
                </Link>
                <Link
                  to="/signup"
                  className="px-4 py-1.5 border border-black dark:border-white/30/40 rounded-full text-[10px] font-bold uppercase tracking-widest bg-black text-white dark:bg-white dark:text-black hover:bg-white hover:text-black dark:hover:bg-[#0a0a0a] dark:hover:text-white transition-colors"
                >
                  Sign up
                </Link>
              </div>
            )}
          </div>
        </div>
      </header>
    </div>
  );
};

export default Navbar;
